import useAuthService from '@/composables/apiServices/useAuthService';
import { EDisabledFeatures } from '@/types/composables/useDisabledFeatureEnums';

const useDisabledFeature = () => {
  const { me } = useAuthService();

  const { suspense: meSuspense } = me();

  const isFeatureDisabled = async (feature: EDisabledFeatures) => {
    if (!feature) return false;
    const meData = await meSuspense();
    const data = meData.data?.disabledFeatures.includes(feature);
    return !!data;
  };

  return { isFeatureDisabled };
};

export default useDisabledFeature;
